import { LinkButton } from "@/components/atoms";
import { EmptyState } from "@/components/molecules";

export const MyDriversEmptyState = ({ hasFilters }: { hasFilters?: boolean }) => {
  const getDescription = () => {
    if (hasFilters) {
      return "There are no drivers matching your filter criteria at the moment.";
    }
    return "You haven't added anything to this section. Get started by clicking the button below.";
  };

  return (
    <EmptyState title="My Drivers" description={getDescription()}>
      {!hasFilters && (
        <div className="flex flex-row gap-4">
          <LinkButton to="../my-drivers/add" variant="primary" startIcon="Add" size="md">
            Add Driver
          </LinkButton>
        </div>
      )}
    </EmptyState>
  );
};
